(function () {
  'use strict';

  angular.module('app').component('bookingList', bookingList());

  function bookingList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowBooking: '&',
      },
      controller: BookinglistCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/booking-list/booking-list.component.html',
    };
  }

  BookinglistCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$location',
    '$filter',
    'moment',
    'AbilityService',
    'BookingService',
    'BookingItemService',
    'SessionService',
    'LocalStoreService',

    // Angular downgraded service
    'companyService',
    'ng2Router',
  ];

  function BookinglistCtrl(
    config,
    UtilService,
    $translate,
    $location,
    $filter,
    moment,
    AbilityService,
    BookingService,
    BookingItemService,
    SessionService,
    LocalStoreService,

    // Angular downgraded service
    companyService,
    ng2Router
  ) {
    var vm = this;

    $translate = $filter('translate');

    vm.permissions = {
      canShow: AbilityService.can('show_booking_accountadmin'),
      canUpdate: AbilityService.can('update_booking_accountadmin'),
      canDestroy: AbilityService.can('destroy_booking_accountadmin'),
      canCreateInvoice: AbilityService.can('create_booking_invoice_booking_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = BookingService.getFilterCriteria();

    vm.bookingStatus = config.BOOKING_STATUS;
    vm.invoicingStatus = config.INVOICING_STATUSES;
    vm.productTypes = config.PRODUCT_TYPES;

    vm.statusOnCart = 'oncart';
    vm.statusDraft = 'draft';
    vm.statusInvoiced = 'invoiced';
    vm.statusProcessing = 'processing';
    vm.statusConfirmed = 'confirmed';
    vm.statusCancelled = 'cancelled';

    vm.itemSearch = {};
    vm.canOpen = true;

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    // Methods
    vm.fetchResult = fetchResult;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;

    vm.filterBookingsByStatus = filterBookingsByStatus;
    vm.filterByPing = filterByPing;
    vm.filterAdvancedData = filterAdvancedData;
    vm.clearAdvancedFilterData = clearAdvancedFilterData;
    vm.closeAdvancedFilterData = closeAdvancedFilterData;

    vm.openSearchByItem = openSearchByItem;
    vm.clearSearchByItem = clearSearchByItem;

    vm.selectItemsType = selectItemsType;
    vm.refresh = refresh;

    vm.openBookingItems = openBookingItems;
    vm.onUpdateItems = onUpdateItems;

    vm.openBookingHistory = openBookingHistory;
    vm.openBookingChangeStatus = openBookingChangeStatus;
    vm.openSendBookingConfirmationToClient = openSendBookingConfirmationToClient;
    vm.downloadBookingVouchers = downloadBookingVouchers;
    vm.openSendBookingItineraryToClient = openSendBookingItineraryToClient;
    vm.openSendBookingVouchersToClient = openSendBookingVouchersToClient;
    vm.openSendInvoiceToClient = openSendInvoiceToClient;
    vm.createInvoiceFromBooking = createInvoiceFromBooking;
    vm.deleteBooking = deleteBooking;

    vm.$onInit = function () {
      // config ??
      vm.bookingTypes = [
        { icon: 'asterisk', title: 'SHOW_ALL', type: 'all' },
        { icon: 'binoculars', title: 'SHOW_TOURS', type: 'tours' },
        { icon: 'truck', title: 'SHOW_TRANSPORTATIONS', type: 'transportations' },
        { icon: 'building', title: 'SHOW_HOTELS', type: 'hotels' },
        { icon: 'suitcase', title: 'SHOW_ITINERARIES', type: 'itinerary' },
      ];

      setServiceDatePicker();
      setCreatedDatePicker();

      // Initializers
      getUsers();

      vm.items_type = vm.bookingTypes[0];
    };

    function setServiceDatePicker() {
      vm.serviceDatePicker = {
        // startDate: moment().startOf('day'),
        // endDate: moment().startOf('day').add(24, 'hour'),

        startDate: vm.UtilService.today(),
        endDate: vm.UtilService.today(),
      };

      vm.serviceDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByServiceDate,
        rangeOptions: config.SERVICE_DATE_OPTIONS,
        dateDisplay: vm.dateDisplay,
        minDate: moment(),
      });
    }

    function setCreatedDatePicker() {
      vm.createdDatePicker = {
        // startDate: moment().subtract(1, 'days'),
        // endDate: moment(),
        startDate: vm.UtilService.today(),
        endDate: vm.UtilService.today(),
      };

      vm.createdDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByCreatedDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: vm.dateDisplay,
        maxDate: moment(),
      });
    }

    function fetchResult() {
      vm.loadingItems = true;
      BookingService.getBookings(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;
        vm.meta.statsBookings = data.stats;

        vm.totalItems = vm.meta.totalItems;

        setBookingItems();

        vm.loadingItems = false;
      });
    }

    function setBookingItems() {
      vm.items.forEach((booking) => {
        var totalBookingItemsConfirmed = 0;

        booking.booking_items.forEach((bookingItem) => {
          if (bookingItem.status === 'confirmed') {
            totalBookingItemsConfirmed += 1;
          }
        });

        booking.allBookingItemsConfirmed =
          booking.booking_items.length === totalBookingItemsConfirmed ? true : false;

        booking.atLeastOneItemIsMissingPickupTime = booking.booking_items.some(
          (bookingItem) =>
            booking.status !== vm.statusOnCart &&
            bookingItem.booking_type !== 'hotel' &&
            !bookingItem.pickup_time
        );

        // console.log(booking.atLeastOneItemIsMissingPickupTime);
      });
    }

    function selectPage(page) {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      fetchResult();
    }

    function showItem(booking, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowBooking({ booking: booking, mode: mode }); // , type: 'booking'
    }

    // SEARCH HEADER

    function filterByPing() {
      if (vm.filteringByPing) {
        vm.filteringByPing = false;

        delete vm.filterCriteria.by_ping;
      } else {
        vm.filteringByPing = true;
        vm.filterCriteria.by_ping = vm.filteringByPing;
      }

      vm.UtilService.filterResult();
    }

    function filterByServiceDate(option) {
      if (option === 'apply') {
        vm.filterCriteria.start_date = vm.serviceDatePicker.startDate.format();
        vm.filterCriteria.end_date = vm.serviceDatePicker.endDate.format();

        vm.serviceDatePickerApplied = true;
      } else {
        vm.serviceDatePicker = {
          startDate: '',
          endDate: '',
        };

        delete vm.filterCriteria.start_date;
        delete vm.filterCriteria.end_date;

        vm.serviceDatePickerApplied = false;
      }

      vm.UtilService.filterResult();
    }

    function filterByCreatedDate(option) {
      if (option === 'apply') {
        vm.filterCriteria.created_at_start = vm.createdDatePicker.startDate.format();
        vm.filterCriteria.created_at_end = vm.createdDatePicker.endDate.format();

        vm.createdDatePickerApplied = true;
      } else {
        vm.createdDatePicker = {
          startDate: '',
          endDate: '',
        };

        delete vm.filterCriteria.created_at_start;
        delete vm.filterCriteria.created_at_end;

        vm.createdDatePickerApplied = false;
      }
    }

    function filterBookingsByStatus(status) {
      if (vm.filterCriteria.by_status === status) {
        return;
      }

      vm.filterCriteria.by_status = status;

      fetchResult();
    }

    function filterAdvancedData() {
      vm.showAdvancedFilterForm = false;
      vm.countAdvancedFilter = 0;

      if (vm.filterCriteria.by_product_type) {
        vm.countAdvancedFilter++;
      }

      if (vm.filterCriteria.by_user_id) {
        vm.countAdvancedFilter++;
      }

      if (vm.filterCriteria.by_product) {
        vm.countAdvancedFilter++;
      }

      if (vm.filterCriteria.by_guest) {
        vm.countAdvancedFilter++;
      }

      if (vm.filterCriteria.by_invoice_status) {
        vm.countAdvancedFilter++;
      }

      if (vm.createdDatePickerApplied) {
        vm.countAdvancedFilter++;
      }

      fetchResult();
    }

    function clearAdvancedFilterData() {
      vm.showAdvancedFilterForm = false;
      vm.createdDatePickerApplied = false;

      vm.createdDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_product_type;
      delete vm.filterCriteria.by_user_id;
      delete vm.filterCriteria.by_product;
      delete vm.filterCriteria.by_guest;
      delete vm.filterCriteria.by_invoice_status;
      delete vm.filterCriteria.created_at_start;
      delete vm.filterCriteria.created_at_end;

      vm.countAdvancedFilter = 0;

      vm.UtilService.filterResult();
    }

    function closeAdvancedFilterData() {
      vm.showAdvancedFilterForm = false;
    }

    function selectItemsType() {
      vm.filterCriteria.items_type = vm.items_type.type;

      vm.UtilService.filterResult();
    }

    function openSearchByItem() {
      if (vm.canOpen) {
        vm.itemSearching = angular.copy(vm.itemSearch);
        BookingService.openSearchByItem(
          vm.itemSearching,
          vm.filteringByItem,
          filterByItem,
          clearSearchByItem
        );
      } else {
        vm.canOpen = true;
      }
    }

    // It helps to add the data needed to filter by item into filter criteria
    function filterByItem(item) {
      vm.filteringByItem = false;
      vm.itemSearch = angular.copy(item);
      vm.filterProductLabel = '';

      delete vm.filterCriteria['item_type'];
      delete vm.filterCriteria['items_type'];
      delete vm.filterCriteria['tour_id'];
      delete vm.filterCriteria['tour_option_id'];
      delete vm.filterCriteria['tour_option_schedule_id'];
      delete vm.filterCriteria['transportation_id'];
      delete vm.filterCriteria['transportation_schedule_id'];

      if (vm.itemSearch) {
        vm.filteringByItem = true;

        switch (vm.itemSearch.itemType.option) {
          case 'itineraries':
            vm.filterProductLabel = $translate('ITINERARIES');
            vm.filterCriteria.item_type = 'itineraries';
            break;
          case 'tours':
            vm.filterProductLabel = $translate('TOURS');
            vm.filterCriteria.item_type = 'tour';
            filterByItemToursInfo();
            break;
          case 'transportations':
            vm.filterProductLabel = $translate('TRANSPORTATIONS');
            vm.filterCriteria.item_type = 'transportation';
            filterByItemTransportationsInfo();
            break;
          case 'hotels':
            vm.filterCriteria.item_type = 'hotel';
            break;
        }
      } else {
        vm.itemSearch = {};
      }

      fetchResult();
    }

    function clearSearchByItem() {
      vm.filteringByItem = false;
      vm.canOpen = false;
      vm.itemSearch = {};

      delete vm.filterCriteria['item_type'];
      delete vm.filterCriteria['items_type'];
      delete vm.filterCriteria['tour_id'];
      delete vm.filterCriteria['tour_option_id'];
      delete vm.filterCriteria['tour_option_schedule_id'];
      delete vm.filterCriteria['transportation_id'];
      delete vm.filterCriteria['transportation_schedule_id'];

      vm.filterProductLabel = '';

      fetchResult();
    }

    function filterByItemToursInfo() {
      if (vm.itemSearch.itemSelected) {
        vm.filterCriteria.tour_id = vm.itemSearch.itemSelected.id;
        vm.filterProductLabel = $translate('TOUR');
      }

      if (vm.itemSearch.tourOption) {
        vm.filterCriteria.tour_option_id = vm.itemSearch.tourOption.id;
      }

      if (vm.itemSearch.departure) {
        vm.filterCriteria.tour_option_schedule_id = vm.itemSearch.departure.id;
      }
    }

    function filterByItemTransportationsInfo() {
      if (vm.itemSearch.itemSelected) {
        vm.filterProductLabel = $translate('TRANSPORTATION');
        vm.filterCriteria.transportation_id = vm.itemSearch.itemSelected.id;
      }
      if (vm.itemSearch.departure) {
        vm.filterCriteria.transportation_schedule_id = vm.itemSearch.departure.id;
      }
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = BookingService.getFilterCriteria();

      vm.serviceDatePicker = {
        startDate: '',
        endDate: '',
      };

      vm.createdDatePicker = {
        startDate: '',
        endDate: '',
      };

      vm.createdDatePickerApplied = false;
      vm.serviceDatePickerApplied = false;

      fetchResult();

      vm.countAdvancedFilter = 0;
    }

    function openBookingItems(booking) {
      BookingItemService.openBookingItemList(booking.id);
    }

    function onUpdateItems(action) {
      BookingService.updateBookings(action, vm.items, fetchResult);
    }

    // ITEM ACTIONS

    function openBookingHistory(booking) {
      BookingService.openBookingHistory(booking);
    }

    function openBookingChangeStatus(booking) {
      if (booking.booking_items.length === 0) return;

      var successCallback = function (bookingObj) {
        booking.status = bookingObj.status;
      };

      BookingService.openBookingChangeStatus(booking, successCallback);
    }

    function openSendBookingConfirmationToClient(booking) {
      if (booking.status !== vm.statusConfirmed) {
        return;
      }

      BookingService.openSendBookingConfirmationToClient(booking); // , {}
    }

    function downloadBookingVouchers(booking) {
      if (!booking.allBookingItemsConfirmed) {
        return;
      }

      booking.booking_items.forEach(function (booking_item) {
        if (booking_item.status === 'confirmed') {
          downloadBookingItemVoucher(booking_item, booking);
        }
      });
    }

    function downloadBookingItemVoucher(booking_item, booking) {
      var params = {
        company_id: booking.company_id,
        skip_check_role: true,
      };

      BookingItemService.downloadBookingItemVoucher(booking_item, params);
    }

    function openSendBookingItineraryToClient(booking) {
      if (!booking.allBookingItemsConfirmed) {
        return;
      }

      BookingService.openSendBookingItineraryToClient(booking, {});
    }

    function openSendBookingVouchersToClient(booking) {
      if (!booking.allBookingItemsConfirmed) {
        return;
      }

      BookingService.openSendBookingVouchersToClient(booking); // , {}
    }

    function openSendInvoiceToClient() {
      return;
    }

    function createInvoiceFromBooking(booking) {
      if (booking.booking_items.length === 0) return;

      let successCallback = function (bookingData) {
        // console.log(bookingData);
        // Local storage
        LocalStoreService.set('bookingData', JSON.stringify(bookingData));

        $location.path(`/invoices/new`).search({
          mode: 'create',
          // fromBooking: 'true',
        });
      };

      BookingService.createBookingInvoice(booking.id, successCallback);
    }

    function deleteBooking(booking) {
      if (!(booking.status === vm.statusDraft || booking.booking_items.length === 0)) {
        // if (booking.status !== vm.statusDraft && booking.booking_items.length > 0) {
        return;
      }

      var successCallback = function () {
        fetchResult();
      };

      BookingService.deleteBooking(booking, successCallback);
    }

    function getUsers() {
      const company = SessionService.getSelectedAccountCompany();
      vm.loadingCompany = true;
      companyService.getCompany(company.id).subscribe((response) => {
        vm.users = response.users;
        vm.loadingCompany = false;
      });
    }

    vm.redirectToBookingReport = function () {
      ng2Router.navigate(['/ng/bookings_report', { showClosedBookings: true }]);
    };

    // function checkPickUpTime(bookingItems) {
    //   console.log(bookingItems);
    //   return bookingItems.some((bookingItem) => bookingItem.type && !bookingItem.pickup_time);
    // }
  }
})();
